export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const LOGOUT_USER = "LOGOUT_USER";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const SET_PROFILE_IMAGE_SUCCESS = "SET_PROFILE_IMAGE_SUCCESS";
